<script lang="ts">
  import OVIcon from "$components/+shared/OVIcon/OVIcon.svelte";
  import { Right } from "$components/+shared/OVIcon";
  import type { IconType } from "$components/+shared/OVIcon/OVIcon";

  export let icon: IconType;
  export let iconColour: string = "text-neutral-400";
  export let title: string;
  export let description: string;
  export let link: string;
  export let ref: HTMLElement;
</script>

<a
  bind:this={ref}
  data-sveltekit-preload-data
  href={link}
  class="group flex w-full items-start gap-2 overflow-hidden rounded-md px-1.5 py-2 hover:bg-neutral-100 focus:bg-neutral-100 dark:hover:bg-white/10 dark:focus:bg-white/10"
>
  <OVIcon {icon} class="mt-0.5 {iconColour} shrink-0" size="size-3.5" />

  <div class="flex grow flex-col gap-1.5 overflow-hidden">
    <h3 class="text-sm font-semibold text-neutral-700 dark:text-neutral-50">{@html title}</h3>
    <div class="flex grow items-center justify-between gap-2 pr-1.5">
      <p class="shrink truncate text-[13px] text-neutral-500 dark:text-neutral-400">
        {@html description}
      </p>
      <OVIcon
        icon={Right}
        class="shrink-0 text-neutral-400 opacity-0 transition-opacity duration-100 group-hover:opacity-100 group-focus:opacity-100"
        size="size-[18px]"
      />
    </div>
    <div class="flex items-center gap-1 text-[11px] font-medium text-neutral-400">
      <slot name="breadcrumbs" />
    </div>
  </div>
</a>
